import { useRef, useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircle2, Info, Terminal, Upload, Cpu } from 'lucide-react';
import { useDiagnosticContext } from '../context/DiagnosticContext';
import { ChooseMethod } from './diagnostic/steps/ChooseMethod';
import { DownloadRun } from './diagnostic/steps/DownloadRun';
import { UploadResults } from './diagnostic/steps/UploadResults';
import { ReportView } from './diagnostic/steps/ReportView';
import styles from './DiagnosticFlow.module.css';

export function DiagnosticFlow() {
  const { currentStep } = useDiagnosticContext();
  const topRef = useRef<HTMLDivElement>(null);

  const STEPS_NAV = [
    { id: 'method', label: 'Choose Method', icon: <Info size={16} /> },
    { id: 'download', label: 'Download & Run', icon: <Terminal size={16} /> },
    { id: 'upload', label: 'Upload Results', icon: <Upload size={16} /> },
    { id: 'report', label: 'Your Report', icon: <Cpu size={16} /> }
  ];

  const currentStepIndex = STEPS_NAV.findIndex(s => s.id === currentStep);

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [currentStep]);

  return (
    <div className="app" ref={topRef}>
      <Header />
      <main className={styles.flowPage}>
        <div className="wrap">
          <nav className={styles.stepper}>
            {STEPS_NAV.map((s, idx) => (
              <div 
                key={s.id} 
                className={`${styles.stepIndicator} ${currentStep === s.id ? styles.active : ''} ${currentStepIndex > idx ? styles.completed : ''}`}
              >
                <div className={styles.stepNum}>
                  {currentStepIndex > idx ? <CheckCircle2 size={18} /> : idx + 1}
                </div>
                <span className={styles.stepLabel}>{s.label}</span>
              </div>
            ))}
          </nav>

          <div className={styles.wizardContent}>
            {currentStep === 'method' && <ChooseMethod />}
            {currentStep === 'download' && <DownloadRun />}
            {currentStep === 'upload' && <UploadResults />}
            {currentStep === 'report' && <ReportView />}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

